const orderDateFormatter = new Intl.DateTimeFormat('en-US', {
	timeZone: 'America/Vancouver',
	year: 'numeric',
	month: 'numeric',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
	second: '2-digit',
	hour12: false,
});

const normalizeDateInput = (value) => {
	if (value instanceof Date) {
		return value;
	}

	if (typeof value === 'number') {
		return new Date(value);
	}

	const stringValue = String(value).trim();
	if (!stringValue) {
		return new Date(NaN);
	}

	const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(stringValue);
	const normalized = hasTimezone
		? stringValue
		: `${stringValue.replace(' ', 'T')}Z`;

	return new Date(normalized);
};

const formatOrderDate = (date) => {
	if (!date) {
		return '';
	}

	const parsedDate = normalizeDateInput(date);
	if (Number.isNaN(parsedDate.getTime())) {
		return '';
	}

	const parts = orderDateFormatter.formatToParts(parsedDate);
	const lookup = Object.fromEntries(
		parts.map((part) => [part.type, part.value]),
	);
	return `${lookup.month}/${lookup.day}/${lookup.year} ${lookup.hour}:${lookup.minute}:${lookup.second}`;
};

export { formatOrderDate };
